<template>
	<div class="col-md-12 col-sm-12 col-xs-12">
		<div class="trans-fillin trans-edit">
			<div class="row">
				<div class="form-header">
					<p>为了顺利开通微信服务, 请如实填写如下查账信息</p>
				</div>	
			</div>
			<div class="row" @click="onFocus" v-if="showBank">
				<div>
					<mt-field label="转出银行名称" placeholder="请输入您转出银行的名称，例如“建设银行”" v-model="trade.bank_name" type="text"></mt-field>
				</div>
			</div>
			<div class="row" @click="onFocus" v-if="showBank">
				<div>
					<mt-field label="付款人姓名" placeholder="请输入您转出银行的户名，例如“张三”" v-model="trade.bank_account_name" type="text"></mt-field>
				</div>
			</div>			
			<div class="row" @click="onFocus" v-if="showTradeNo">
				<div>
					<mt-field :label="lblTradeNo" :placeholder="plTradeNo" v-model="trade.trade_no" type="tel" :attr="attr"></mt-field>
				</div>
			</div>
			<div class="row" @click="onFocus" v-if="showAlipayId">
				<div>
					<mt-field label="付款人姓名" placeholder="请输入您的真实姓名" v-model="trade.alipay_id" type="text"></mt-field>
				</div>
			</div>
			<div class="row" @click="onFocus">
				<div>
					<mt-field label="支付金额" placeholder="请输入您的支付金额" v-model="trade.amount" type="tel" :attr="attr" disableClear></mt-field>
				</div>
			</div>
			<div class="row" @click="onPaidTimeClick">
				<div>
					<mt-field label="支付日期" placeholder="请输入您的支付日期" v-model="trade.paid_time" type="text" readonly></mt-field>
				</div>
			</div>
			<div class="row">
				<div class="actions mt-50">
					<mt-button type="primary" @click="onSubmitClick">保存</mt-button>
					<mt-button type="danger" @click="onDelClick">删除</mt-button>
				</div>
			</div>
			<mt-datetime-picker ref="picker" type="datetime" v-model="pickerValue" @confirm="handleConfirm" :startDate="startDate" :endDate="endDate"></mt-datetime-picker>			
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Button, Field, DatetimePicker, MessageBox } from 'mint-ui'

export default {
	name: 'TransFillEdit',
	data: () => ({
		'trade': {
			'payment_id': 0,
			'trade_no': null,
			'amount': null,
			'paid_time': null,
			'route_code': 'P0000',
			'payment_way': null,
			'bank_name': null,
			'bank_account_name': null,
			'alipay_id': null,
			'vendor_title': null
		},
		'pickerValue': new Date(),
		'endDate': new Date(),
		'startDate': new Date(),
		'showTradeNo': true,
		'showBank': false,
		'showBankInfo': false,
		'showAlipayId': false,
		'lblTradeNo': '交易单号',
		'plTradeNo': '请粘贴/输入交易单号',
		'attr': {'style': {'ime-mode': 'disabled'}}
	}),
	computed: {
		...mapGetters({
			orderInfo: 'getOrder',
			payment: 'getPayment'
		})
	},
	components: {
		'mt-button': Button,
		'mt-field': Field,
		'mt-datetime-picker': DatetimePicker
	},
	created: function () {
	},
	mounted: function () {
		this.startDate = new Date()
		if (this.startDate.getMonth() > 0) {
			this.startDate.setFullYear(this.startDate.getFullYear(), this.startDate.getMonth() - 1)
		} else {
			this.startDate.setFullYear(this.startDate.getFullYear(), this.startDate.getMonth(), 1)
		}
		this.endDate = new Date()
		this.setPageTitle('收款方: ' + this.payment.payment_way)
		Object.assign(this.trade, this.payment)
		const paidTime = this.parsePaidTime(this.trade.paid_time)
		if (paidTime) {
			this.pickerValue = paidTime
			if (paidTime < this.startDate) {
				this.startDate = new Date(paidTime.getTime())
			}
			if (paidTime > this.endDate) {
				this.endDate = new Date(paidTime.getTime())
			}
		}
		this.showTradeNo = false
		if (this.payment.crm_pay_code === 'weixin_pay') {
			this.showAlipayId = false
			this.lblTradeNo = '交易单号'
			this.plTradeNo = '请粘贴/输入微信交易单号'
			this.showTradeNo = true
		} else if (this.payment.crm_pay_code === 'ali_pay') {
			this.showAlipayId = true
			this.lblTradeNo = '订单号'
			this.plTradeNo = '请粘贴/输入支付宝订单号'
			this.showTradeNo = true
		}
		this.showBank = !this.showTradeNo
	},
	methods: {
		parsePaidTime (value) {
			if (value instanceof Date) {
				return isNaN(value.getTime()) ? null : new Date(value.getTime())
			}
			if (typeof value !== 'string') {
				return null
			}
			const parts = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/)
			if (!parts) {
				return null
			}
			const date = new Date(
				parseInt(parts[1], 10),
				parseInt(parts[2], 10) - 1,
				parseInt(parts[3], 10),
				parseInt(parts[4] || 0, 10),
				parseInt(parts[5] || 0, 10),
				parseInt(parts[6] || 0, 10)
			)
			return isNaN(date.getTime()) ? null : date
		},
		onSubmitClick () {
			console.log(this.trade)
			if (this.showBank) {
				if (!this.trade.bank_name || this.trade.bank_name.length === 0) {
					this.toast('请输入您转出银行的名称')
					return
				}
				if (!this.trade.bank_account_name || this.trade.bank_account_name.length === 0) {
					this.toast('请输入您转出银行的户名')
					return
				}
			}
			if (!this.trade.amount || this.trade.amount.length === 0) {
				this.toast('请输入您的支付金额')
				return
			}
			if (parseFloat(this.trade.amount) <= 0 || isNaN(parseFloat(this.trade.amount))) {
				this.toast('转账金额必须大于0')
				return
			}
			if (!this.trade.paid_time || this.trade.paid_time.length === 0) {
				this.toast('请输入您的支付日期')
				return
			}
			if (this.showTradeNo) {
				if (!this.trade.trade_no || this.trade.trade_no.length === 0) {
					this.toast('请输入' + this.lblTradeNo)
					return
				}
			}
			if (this.showAlipayId) {
				if (!this.trade.alipay_id || this.trade.alipay_id.length === 0) {
					this.toast('请输入您的真实姓名')
					return
				}
			}
			if (this.trade.trade_no && !/^([0-9]+)$/.test(this.trade.trade_no)) {
				this.toast(this.lblTradeNo + '格式不正确, 请输入数字')
				return
			}
			let url = '/api/orders/payments/trans/' + this.orderInfo.order_no
			this.loading('正在保存...')
			this.$http.put(url, this.trade).then(response => {
				this.loadingHide()
				var rs = response.body
				if (rs.code === 0) {
					console.log('result: ', rs.data.order)
					this.$store.dispatch('setOrder', {'order': rs.data.order})
					this.$store.dispatch('setTransList', {'items': []})
					this.toast('保存成功')
					this.$router.go(-1)
				} else {
					if (rs.code === 10666) {
						this.toast(this.lblTradeNo + '已存在，不能重复使用，请确认您的输入')
					} else {
						this.handleHttpError(response)
					}
				}
			}, response => {
				console.log(response)
				this.handleHttpError(response)
			})
		},
		onDelClick () {
			MessageBox.confirm('您确定删除该查账信息吗？').then(action => {
				if (action === 'confirm') {
					let url = '/api/payments/' + this.payment.payment_id
					this.loading('正在删除...')
					this.$http.delete(url).then(response => {
						this.loadingHide()
						var rs = response.body
						if (rs.code === 0) {
							console.log('result: ', rs.data)
							this.$store.dispatch('setOrder', {'order': rs.data})
							this.$store.dispatch('setTransList', {'items': []})
							this.toast('删除成功')
							this.$router.go(-1)
						} else {
							this.handleHttpError(response)
						}
					}, response => {
						console.log(response)
						this.handleHttpError(response)
					})
				}
			}, action => {
				console.log(action)
			})
		},
		onFocus (e) {
			let ele = e.target
			if (!ele) {
				ele = e.srcElement
			}
			// console.log(ele)
			if (ele.tagName !== 'input') {
			}
			ele.focus()
		},
		onPaidTimeClick () {
			this.$refs.picker.open()
		},
		toShowBankInfo () {
			this.showBankInfo = !this.showBankInfo
		},
		onCopied () {
			this.toast('复制成功')
		},
		handleConfirm () {
			console.log(this.pickerValue)
			this.trade.paid_time = this.formatDate(this.pickerValue, 'yyyy-MM-dd HH:mm:ss')
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/payment/TransEdit.vue